<template>
    <div>
        <!-- Begin:PageContent -->
        <section id="content">
            <div class="container">
                <div class="row">
                    <!-- Begin: -->
                    <div id="main" class="col-md-9">
                        <div class="container shortcode travel-ideas">
                            <h1 class="idea-title">
                                <span class="index">
                                    <i class="soap-icon-star circle"></i>
                                </span>
                                {{ titleinfo[getCurrentLocale] }}
                            </h1>
                        </div>
                        <br />

                        <div class="booking-information sdr-box">
                            <h4 v-html="covid19_h4_2[getCurrentLocale]"></h4><br />
                            <p v-html="covid19_20[getCurrentLocale]"></p><br /><br />


                            <h4 v-html="covid19_h4_1[getCurrentLocale]"></h4><br />
                            <p v-html="covid19_140[getCurrentLocale]"></p>
                            <p v-html="covid19_141[getCurrentLocale]"></p>
                            <p v-html="covid19_142[getCurrentLocale]"></p><br /><br />

                            <br /><p>Update: 14.06.2021</p>
                        </div>
                    </div>
                    <!-- End: -->

                    <!-- Begin:Content-SideBar -->
                    <div class="sidebar col-md-3">
                        <sdr-aboutsundair-box></sdr-aboutsundair-box>
                        <sdr-contact-box></sdr-contact-box>
                    </div>
                    <!-- END:Content-SideBar -->
                </div>
            </div>
        </section>
        <!-- End:PageContent -->

        <!-- Begin:PromoBox -->
        <sdr-promobox></sdr-promobox>
        <!-- End:PromoBox -->
    </div>
</template>

<script>
    import AboutSundairBox from '../../shared/sidebar/AboutSundairBox.vue'; // Sidebar (right)
    import ContactBox from '../../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import PromoBox from '../../booking/pagecontent/PromoBox.vue';

    import { mapGetters } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-aboutsundair-box': AboutSundairBox,
            'sdr-contact-box': ContactBox,
            'sdr-promobox': PromoBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                titleinfo: {
                    en: 'Important Informations',
                    de: 'Wichtige Informationen',
                },
                // >>> --------------------------
                covid19_h4_2 : {
                    en: 'Flüge von Berlin – Beirut – Berlin, Hannover - Beirut - Hannover und Düsseldorf – Beirut - Düsseldorf:',
                    de: 'Flüge von Berlin – Beirut – Berlin, Hannover - Beirut - Hannover und Düsseldorf – Beirut - Düsseldorf:',
                },
                covid19_20 : {
                    en: 'Fly with us on Mon, Wed and Fri at favourable ticket prices and baggage conditions.<br />Among other things, infants up to the age of 2 travel free of charge and receive 10 kg free baggage allowance.<br /><br />Excess baggage charges:<br />with online reservation 10 EUR per kg;<br />at check-in 15 EUR per kg.<br /><br />Wheelchair registrations: Please send your request to <a href="mailto:kundenservice@sundair.com" target="_blank" style="font-weight: 600; color: red; text-decoration: underline;">kundenservice@sundair.com</a> at least 2 days before flight.<br /><br />For detailed information, please contact our customer service team on +49 30 81455700 ',
                    de: 'Fliegen Sie mit uns jeweils Mo, Mi und Fr zu günstigen Ticketpreisen und Gepäckkonditionen.<br />Kleinkinder reisen bis zum vollendeten 2. Lebensjahr kostenlos und erhalten 10 kg Freigepäck.<br /><br />Übergepäck-Gebühren:<br />bei Online-Reservierung 10 EUR je kg;<br />am Check-in 15 EUR je kg.<br /><br />Rollstuhl-Anmeldungen: bitte spätestens 2 Tage vor Flug per E-Mail an <a href="mailto:kundenservice@sundair.com" target="_blank" style="font-weight: 600; color: red; text-decoration: underline;">kundenservice@sundair.com</a>.<br /><br />Detaillierte Informationen erhalten Sie von unserem Kundenservice-Team unter Tel. +49 30 81455700 ',
                },
                // >>> --------------------------
                covid19_h4_1 : {
                    en: 'Important notice for passengers traveling to Beirut:',
                    de: 'Wichtiger Hinweis für Reisende nach Beirut:',
                },
                covid19_140 : {
                    en: 'All passengers over 12 years of age arriving from a country/area of risk in relation to SARS-CoV-2 coronavirus, has to present at the check-in counter a printed certificate with a negative PCR test result performed not earlier than 96 hours prior to the estimated time of arrival to Lebanon. It must be stamped and signed by a lab certified by the Countries local authorities. A test result in English or Arabic language is highly recommended.<br /><br />',
                    de: 'Derzeit muss von allen Passagieren ab einem Alter von zwölf Jahren vor Abflug ein negatives PCR-Testergebnis eines anerkannten Labors vorgelegt werden, welches bei Ankunft im Libanon nicht älter als 96 Stunden sein darf.<br /><br />',
                },
                covid19_141 : {
                    en: 'This does not apply to:<br /><br />•	passengers with a vaccination card with 2 documented COVID-19 vaccinations Requirements:<br />•	The Vaccination certificate must be issued by an European Country, Lebanon or a country according Country list*<br />•	the last vaccine dose has been received at least 15 days before departure.<br />•	The Vaccination card must be presented at the check-in. Copies or photos will not be accepted.<br />•	The surname, first name entered in the vaccination card must match the surname, first name in the passport.<br /><br />* Information regarding Country List are available on request from SUNDAIR Customer Service team ',
                    de: 'Ausnahme: Passagiere, die bereits zwei (2) COVID-19- Impfungen erhalten haben.<br /><br />Voraussetzungen:<br />•	Die beiden Impfungen haben in einem europäischen Land, im Libanon oder einem Land gemäß Länderliste* stattgefunden.<br />•	Seit der 2. Impfung sind mindestens 15 Tage vergangen.<br />•	Der Impfausweis muss im Original am Check-in vorgezeigt und auf der Reise mitgeführt werden. Kopien oder Fotos sind unzulässig.<br />•	Der eingetragene Name, Vorname im Impfausweis muss mit dem Namen, Vornamen im Reisepass übereinstimmen.<br /><br />*Informationen zu weiteren Ländern erhalten Sie auf Nachfrage beim Kundenservice-Team ',
                },
                covid19_142 : {
                    en: 'Effective from 11.01.2021 a second PCR test is required. All passengers, except children under 12 years age, must perform a PCR test upon arrival. The test fee is payable at the check in counter. According to the decree of the Lebanese Authorities this applies also for passengers with 2 documented COVID-19 vaccinations.<br /><br />Effective from 27.01.2021 all passengers over 12 years of age shall fill in the form available electronically through website <a href="https://covid.pcm.gov.lb/impactmobile/curfew" target="_blank" style="font-weight: 600; color: red; text-decoration: underline;">https://covid.pcm.gov.lb/impactmobile/curfew</a> and show the received approval by email or SMS before their Check-in to Lebanon.Boarding passes will only be issued if all regulations are met.',
                    de: 'Ab dem 11.01.2021 muss nach Ankunft im Libanon ein zweiter PCR-Test durchgeführt werden. Die Testgebühr ist von allen Fluggästen spätestens am Check-in zu entrichten. Auf Anordnung der libanesischen Behörden gilt dies auch für Passagiere, die bereits 2 Impfungen erhalten haben. <br /><br />Ab dem 27.01.2021 müssen alle Passagiere ab einem Alter von 12 Jahren vor Abflug einen Nachweis ihrer Registrierung auf der Webseite <a href="https://covid.pcm.gov.lb/impactmobile/curfew" target="_blank" style="font-weight: 600; color: red; text-decoration: underline;">https://covid.pcm.gov.lb/impactmobile/curfew</a> vorweisen.<br /><br />Sollten die geforderten Dokumente bei Abflug nicht vorliegen, kann Ihnen die Beförderung auf dem Flug verweigert werden.',
                },
                // >>> --------------------------

                // getCurrentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    a[target='_blank']:after {
        font-family: 'FontAwesome';
        content: ' \f08e';
    }

    /* >>>  iPAD -------------------------------------------------------------*/
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        h1 {
            font-size: 1.6em;
        }
        .booking-information {
            padding: 20px 30px 30px;
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 30px;
            padding-left: 15px;
        }
    }
</style>